import React, { useEffect, useState } from 'react';
import { Field, fieldClass } from './shared';

export const invoiceRuleLabel = value => {
  const rule = typeof value === 'string' ? { selection: value } : value;
  if (rule?.selection === 'due_date_offset') {
    const days = Number(rule.days_offset);
    if (days === 0) return 'Invoice due today';
    const amount = `${rule.comparison === 'at_least' ? 'at least ' : 'exactly '}${Math.abs(days)} days`;
    return days < 0 ? `Invoice due in ${amount}` : `Invoice overdue by ${amount}`;
  }
  return ({ oldest_overdue: 'Oldest overdue invoice', next_due: 'Next invoice due', oldest_pending: 'Oldest pending invoice', manual: 'Select invoices manually', filtered: 'Earliest invoice matching recipient filters' }[rule?.selection] || 'Not configured');
};

export default function FinancialRule({ value, onChange, readonly, allowFiltered = false }) {
  const isOffset = value?.selection === 'due_date_offset';
  const mode = isOffset ? value.days_offset < 0 ? 'before' : value.days_offset > 0 ? 'after' : 'today' : value?.selection || '';
  const [days, setDays] = useState(String(Math.abs(value?.days_offset || 5)));
  useEffect(() => { setDays(String(Math.abs(value?.days_offset || 5))); }, [value?.days_offset]);
  function changeMode(next) {
    if (['before', 'today', 'after'].includes(next)) onChange({ selection: 'due_date_offset', days_offset: next === 'today' ? 0 : next === 'before' ? -5 : 20, comparison: 'exact' });
    else onChange(next ? { selection: next } : null);
  }
  return <div className="flex flex-col gap-3 rounded border border-orange-200 bg-orange-50 p-3">
    <Field label="Send only when the invoice matches" required><select required disabled={readonly} className={fieldClass} value={mode} onChange={event => changeMode(event.target.value)}>
      <option value="">Choose an invoice rule</option>
      {allowFiltered && <option value="filtered">Earliest invoice matching recipient filters</option>}
      <option value="before">Due in a number of days</option>
      <option value="today">Due today</option>
      <option value="after">Overdue by a number of days</option>
      <option value="oldest_overdue">Any overdue invoice (oldest first)</option>
      <option value="next_due">Any upcoming invoice (earliest first)</option>
      <option value="oldest_pending">Any pending invoice (oldest first)</option>
      <option value="manual">Select invoices manually</option>
    </select></Field>
    {isOffset && mode !== 'today' && <div className="flex gap-3">
      <Field label="Match" required><select className={fieldClass} disabled={readonly} value={value.comparison || 'exact'} onChange={event => onChange({ ...value, comparison: event.target.value })}>
        <option value="exact">Exactly</option><option value="at_least">At least</option>
      </select></Field>
      <Field label={mode === 'before' ? 'Days before due date' : 'Days overdue'} required><input type="number" min={1} max={3650} step={1} required disabled={readonly} className={fieldClass} value={days}
        onChange={event => {
          const next = event.target.value;
          if (next === '') { setDays(''); return; }
          const number = Number(next);
          if (!Number.isInteger(number) || number < 1 || number > 3650) return;
          setDays(String(number));
          onChange({ ...value, days_offset: mode === 'before' ? -number : number });
        }}
        onBlur={() => setDays(String(Math.abs(value.days_offset)))} />
        <span className="text-xs text-gray-600">Enter a positive number from 1 to 3650. The rule above determines before or after the due date.</span>
      </Field>
    </div>}
    <p className="text-xs text-gray-600">{invoiceRuleLabel(value)}. Evaluated against the date of review and sending. {allowFiltered ? "The financial filters in Recipients also apply." : "Only pending invoices with a balance qualify."} If several match, the oldest due date is used.</p>
  </div>;
}
